export interface NameData {
  name: string;
  category: 'feminine' | 'masculine' | 'neutral' | 'toys' | 'utilities' | 'clothes';
}

export const NAMES_DATABASE: NameData[] = [
  // Feminine
  { name: "Helena", category: "feminine" },
  { name: "Alice", category: "feminine" },
  { name: "Laura", category: "feminine" },
  { name: "Maria Alice", category: "feminine" },
  { name: "Sophia", category: "feminine" },
  { name: "Manuela", category: "feminine" },
  { name: "Maitê", category: "feminine" },
  { name: "Liz", category: "feminine" },
  { name: "Cecília", category: "feminine" },
  { name: "Isabella", category: "feminine" },
  { name: "Luísa", category: "feminine" },
  { name: "Eloá", category: "feminine" },
  { name: "Ayla", category: "feminine" },
  { name: "Antonella", category: "feminine" },
  { name: "Maya", category: "feminine" },
  { name: "Giulia", category: "feminine" },
  { name: "Valentina", category: "feminine" },
  { name: "Heloísa", category: "feminine" },
  { name: "Aurora", category: "feminine" },
  { name: "Lorena", category: "feminine" },
  { name: "Giovanna", category: "feminine" },
  { name: "Beatriz", category: "feminine" },
  { name: "Maria Clara", category: "feminine" },
  { name: "Maria Cecília", category: "feminine" },
  { name: "Maria Julia", category: "feminine" },
  { name: "Mariana", category: "feminine" },
  { name: "Lara", category: "feminine" },
  { name: "Ana Clara", category: "feminine" },
  { name: "Isadora", category: "feminine" },
  { name: "Melissa", category: "feminine" },
  { name: "Stella", category: "feminine" },
  { name: "Catarina", category: "feminine" },
  { name: "Lavínia", category: "feminine" },
  { name: "Maria Luísa", category: "feminine" },
  { name: "Olívia", category: "feminine" },
  { name: "Maria Fernanda", category: "feminine" },
  { name: "Esther", category: "feminine" },
  { name: "Sarah", category: "feminine" },
  { name: "Maria Eduarda", category: "feminine" },
  { name: "Vitória", category: "feminine" },
  { name: "Maria Helena", category: "feminine" },
  { name: "Clara", category: "feminine" },
  { name: "Luna", category: "feminine" },
  { name: "Rafaela", category: "feminine" },
  { name: "Alícia", category: "feminine" },
  { name: "Bia", category: "feminine" },
  { name: "Larissa", category: "feminine" },
  { name: "Yasmin", category: "feminine" },
  { name: "Emanuelly", category: "feminine" },
  { name: "Rebeca", category: "feminine" },
  { name: "Brenda", category: "feminine" },
  { name: "Ana Júlia", category: "feminine" },
  { name: "Letícia", category: "feminine" },
  { name: "Agatha", category: "feminine" },
  { name: "Lívia", category: "feminine" },
  { name: "Bianca", category: "feminine" },
  { name: "Clarice", category: "feminine" },
  { name: "Pérola", category: "feminine" },
  { name: "Zoe", category: "feminine" },
  { name: "Mirella", category: "feminine" },
  { name: "Eduarda", category: "feminine" },
  { name: "Tereza", category: "feminine" },
  { name: "Luma", category: "feminine" },
  { name: "Gabriela", category: "feminine" },
  { name: "Carolina", category: "feminine" },
  { name: "Aline", category: "feminine" },
  { name: "Bruna", category: "feminine" },
  { name: "Camila", category: "feminine" },
  { name: "Daniela", category: "feminine" },
  { name: "Elaine", category: "feminine" },
  { name: "Fabiana", category: "feminine" },
  { name: "Gisele", category: "feminine" },
  { name: "Ingrid", category: "feminine" },
  { name: "Jéssica", category: "feminine" },
  { name: "Luana", category: "feminine" },
  { name: "Marta", category: "feminine" },
  { name: "Natália", category: "feminine" },
  { name: "Paula", category: "feminine" },
  { name: "Renata", category: "feminine" },
  { name: "Simone", category: "feminine" },
  { name: "Tatiane", category: "feminine" },
  { name: "Ursula", category: "feminine" },
  { name: "Vanessa", category: "feminine" },
  { name: "Xuxa", category: "feminine" },
  { name: "Yara", category: "feminine" },
  { name: "Zilda", category: "feminine" },
  { name: "Adriana", category: "feminine" },
  { name: "Andreia", category: "feminine" },
  { name: "Barbara", category: "feminine" },
  { name: "Carla", category: "feminine" },
  { name: "Debora", category: "feminine" },
  { name: "Elisa", category: "feminine" },
  { name: "Fernanda", category: "feminine" },
  { name: "Glauce", category: "feminine" },
  { name: "Iara", category: "feminine" },
  { name: "Jaqueline", category: "feminine" },
  { name: "Karina", category: "feminine" },
  { name: "Lilian", category: "feminine" },
  { name: "Maira", category: "feminine" },
  { name: "Nayara", category: "feminine" },
  { name: "Patricia", category: "feminine" },
  { name: "Raquel", category: "feminine" },
  { name: "Sonia", category: "feminine" },
  { name: "Talita", category: "feminine" },
  { name: "Viviane", category: "feminine" },
  { name: "Amanda", category: "feminine" },
  { name: "Cristina", category: "feminine" },
  { name: "Denise", category: "feminine" },
  { name: "Erika", category: "feminine" },
  { name: "Flavia", category: "feminine" },
  { name: "Graziele", category: "feminine" },
  { name: "Ivana", category: "feminine" },
  { name: "Joana", category: "feminine" },
  { name: "Katia", category: "feminine" },
  { name: "Luciana", category: "feminine" },
  { name: "Monica", category: "feminine" },
  { name: "Neide", category: "feminine" },
  { name: "Priscila", category: "feminine" },
  { name: "Rosana", category: "feminine" },
  { name: "Sandra", category: "feminine" },
  { name: "Tania", category: "feminine" },
  { name: "Valeria", category: "feminine" },
  { name: "Zuleica", category: "feminine" },
  { name: "Angélica", category: "feminine" },
  { name: "Dandara", category: "feminine" },
  { name: "Eliana", category: "feminine" },
  { name: "Fátima", category: "feminine" },
  { name: "Gláucia", category: "feminine" },
  { name: "Hilda", category: "feminine" },
  { name: "Isabel", category: "feminine" },
  { name: "Jandira", category: "feminine" },
  { name: "Katarina", category: "feminine" },
  { name: "Lourdes", category: "feminine" },
  { name: "Magda", category: "feminine" },
  { name: "Nair", category: "feminine" },
  { name: "Odete", category: "feminine" },
  { name: "Palmira", category: "feminine" },
  { name: "Quitéria", category: "feminine" },
  { name: "Rute", category: "feminine" },
  { name: "Suely", category: "feminine" },
  { name: "Teresa", category: "feminine" },
  { name: "Ubaldina", category: "feminine" },
  { name: "Vera", category: "feminine" },
  { name: "Waldira", category: "feminine" },
  { name: "Xênia", category: "feminine" },
  { name: "Yolanda", category: "feminine" },
  { name: "Zélia", category: "feminine" },
  { name: "Araci", category: "feminine" },
  { name: "Benedita", category: "feminine" },
  { name: "Conceição", category: "feminine" },
  { name: "Dalva", category: "feminine" },
  { name: "Edite", category: "feminine" },
  { name: "Filomena", category: "feminine" },
  { name: "Genoveva", category: "feminine" },
  { name: "Hermínia", category: "feminine" },
  { name: "Inês", category: "feminine" },
  { name: "Jovina", category: "feminine" },
  { name: "Liduvina", category: "feminine" },
  { name: "Minervina", category: "feminine" },
  { name: "Norma", category: "feminine" },
  { name: "Olinda", category: "feminine" },
  { name: "Piedade", category: "feminine" },
  { name: "Querubina", category: "feminine" },
  { name: "Rosália", category: "feminine" },
  { name: "Sebastiana", category: "feminine" },
  { name: "Teodora", category: "feminine" },
  { name: "Umbelina", category: "feminine" },
  { name: "Vicência", category: "feminine" },
  { name: "Zenaide", category: "feminine" },

  // Masculine
  { name: "Miguel", category: "masculine" },
  { name: "Gael", category: "masculine" },
  { name: "Heitor", category: "masculine" },
  { name: "Théo", category: "masculine" },
  { name: "Davi", category: "masculine" },
  { name: "Gabriel", category: "masculine" },
  { name: "Bernardo", category: "masculine" },
  { name: "Samuel", category: "masculine" },
  { name: "João Miguel", category: "masculine" },
  { name: "Ravi", category: "masculine" },
  { name: "Lorenzo", category: "masculine" },
  { name: "Pedro", category: "masculine" },
  { name: "Levi", category: "masculine" },
  { name: "Matheus", category: "masculine" },
  { name: "Lucas", category: "masculine" },
  { name: "Nicolas", category: "masculine" },
  { name: "Joaquim", category: "masculine" },
  { name: "Henrique", category: "masculine" },
  { name: "Rafael", category: "masculine" },
  { name: "Guilherme", category: "masculine" },
  { name: "Enzo", category: "masculine" },
  { name: "Murilo", category: "masculine" },
  { name: "Benício", category: "masculine" },
  { name: "Gustavo", category: "masculine" },
  { name: "João Pedro", category: "masculine" },
  { name: "Felipe", category: "masculine" },
  { name: "Daniel", category: "masculine" },
  { name: "Pedro Henrique", category: "masculine" },
  { name: "Bento", category: "masculine" },
  { name: "Leonardo", category: "masculine" },
  { name: "Vicente", category: "masculine" },
  { name: "Eduardo", category: "masculine" },
  { name: "João Lucas", category: "masculine" },
  { name: "Antônio", category: "masculine" },
  { name: "Emanuel", category: "masculine" },
  { name: "Enzo Gabriel", category: "masculine" },
  { name: "Caio", category: "masculine" },
  { name: "Davi Lucca", category: "masculine" },
  { name: "Caleb", category: "masculine" },
  { name: "Otávio", category: "masculine" },
  { name: "Francisco", category: "masculine" },
  { name: "João", category: "masculine" },
  { name: "Luan", category: "masculine" },
  { name: "Luiz", category: "masculine" },
  { name: "Kaique", category: "masculine" },
  { name: "Augusto", category: "masculine" },
  { name: "Renan", category: "masculine" },
  { name: "Cauã", category: "masculine" },
  { name: "Igor", category: "masculine" },
  { name: "Diego", category: "masculine" },
  { name: "Bruno", category: "masculine" },
  { name: "Rodrigo", category: "masculine" },
  { name: "Fernando", category: "masculine" },
  { name: "Marcelo", category: "masculine" },
  { name: "Ricardo", category: "masculine" },
  { name: "Alexandre", category: "masculine" },
  { name: "Anderson", category: "masculine" },
  { name: "Carlos", category: "masculine" },
  { name: "Danilo", category: "masculine" },
  { name: "Everton", category: "masculine" },
  { name: "Fabio", category: "masculine" },
  { name: "Gilberto", category: "masculine" },
  { name: "Hugo", category: "masculine" },
  { name: "Ivan", category: "masculine" },
  { name: "Jonas", category: "masculine" },
  { name: "Kleber", category: "masculine" },
  { name: "Leandro", category: "masculine" },
  { name: "Mauricio", category: "masculine" },
  { name: "Nelson", category: "masculine" },
  { name: "Osvaldo", category: "masculine" },
  { name: "Paulo", category: "masculine" },
  { name: "Ronaldo", category: "masculine" },
  { name: "Sergio", category: "masculine" },
  { name: "Thiago", category: "masculine" },
  { name: "Umberto", category: "masculine" },
  { name: "Valter", category: "masculine" },
  { name: "Wagner", category: "masculine" },
  { name: "Xavier", category: "masculine" },
  { name: "Yago", category: "masculine" },
  { name: "Zeca", category: "masculine" },
  { name: "Afonso", category: "masculine" },
  { name: "Benedito", category: "masculine" },
  { name: "Cesar", category: "masculine" },
  { name: "Douglas", category: "masculine" },
  { name: "Edmilson", category: "masculine" },
  { name: "Flavio", category: "masculine" },
  { name: "Geraldo", category: "masculine" },
  { name: "Helio", category: "masculine" },
  { name: "Ismael", category: "masculine" },
  { name: "Jorge", category: "masculine" },
  { name: "Kauan", category: "masculine" },
  { name: "Luis", category: "masculine" },
  { name: "Mario", category: "masculine" },
  { name: "Newton", category: "masculine" },
  { name: "Otavio", category: "masculine" },
  { name: "Pascoal", category: "masculine" },
  { name: "Quirino", category: "masculine" },
  { name: "Raul", category: "masculine" },
  { name: "Wilson", category: "masculine" },
  { name: "Xerxes", category: "masculine" },
  { name: "Youssef", category: "masculine" },
  { name: "Zaqueu", category: "masculine" },
  { name: "Alberto", category: "masculine" },
  { name: "Beto", category: "masculine" },
  { name: "Claudio", category: "masculine" },
  { name: "Dario", category: "masculine" },
  { name: "Elias", category: "masculine" },
  { name: "Fausto", category: "masculine" },
  { name: "Genival", category: "masculine" },
  { name: "Humberto", category: "masculine" },
  { name: "Inacio", category: "masculine" },
  { name: "Jose", category: "masculine" },
  { name: "Kenji", category: "masculine" },
  { name: "Laercio", category: "masculine" },
  { name: "Milton", category: "masculine" },
  { name: "Nivaldo", category: "masculine" },
  { name: "Olavo", category: "masculine" },
  { name: "Plinio", category: "masculine" },
  { name: "Queiroz", category: "masculine" },
  { name: "Rubens", category: "masculine" },
  { name: "Saulo", category: "masculine" },
  { name: "Tiago", category: "masculine" },
  { name: "Ulisses", category: "masculine" },
  { name: "Valdir", category: "masculine" },
  { name: "Waldir", category: "masculine" },
  { name: "Xande", category: "masculine" },
  { name: "Zenon", category: "masculine" },
  { name: "Alisson", category: "masculine" },
  { name: "Bráulio", category: "masculine" },
  { name: "Ciro", category: "masculine" },
  { name: "Dênis", category: "masculine" },
  { name: "Eder", category: "masculine" },
  { name: "Franklin", category: "masculine" },
  { name: "Gerson", category: "masculine" },
  { name: "Haroldo", category: "masculine" },
  { name: "Ivaldo", category: "masculine" },
  { name: "Jarbas", category: "masculine" },
  { name: "Kléber", category: "masculine" },
  { name: "Lineu", category: "masculine" },
  { name: "Moacir", category: "masculine" },
  { name: "Norberto", category: "masculine" },
  { name: "Oseas", category: "masculine" },
  { name: "Pepeu", category: "masculine" },
  { name: "Quincas", category: "masculine" },
  { name: "Rivaldo", category: "masculine" },
  { name: "Sivaldo", category: "masculine" },
  { name: "Túlio", category: "masculine" },
  { name: "Ubaldo", category: "masculine" },
  { name: "Vivaldo", category: "masculine" },
  { name: "Wanderley", category: "masculine" },
  { name: "Xisto", category: "masculine" },
  { name: "Yanis", category: "masculine" },
  { name: "Zoroastro", category: "masculine" },

  // Neutral
  { name: "Alex", category: "neutral" },
  { name: "Ali", category: "neutral" },
  { name: "Ariel", category: "neutral" },
  { name: "Beni", category: "neutral" },
  { name: "Cris", category: "neutral" },
  { name: "Dani", category: "neutral" },
  { name: "Dominique", category: "neutral" },
  { name: "Eli", category: "neutral" },
  { name: "Fran", category: "neutral" },
  { name: "Gabi", category: "neutral" },
  { name: "Jade", category: "neutral" },
  { name: "Jean", category: "neutral" },
  { name: "Kai", category: "neutral" },
  { name: "Luca", category: "neutral" },
  { name: "Mika", category: "neutral" },
  { name: "Pat", category: "neutral" },
  { name: "Rene", category: "neutral" },
  { name: "Sacha", category: "neutral" },
  { name: "Sam", category: "neutral" },
  { name: "Val", category: "neutral" },
  { name: "Vic", category: "neutral" },
  { name: "Yael", category: "neutral" },
  { name: "Jia", category: "neutral" },
  { name: "Jo", category: "neutral" },
  { name: "Sol", category: "neutral" },
  { name: "Duda", category: "neutral" },
  { name: "Manu", category: "neutral" },
  { name: "Lulu", category: "neutral" },
  { name: "Cuca", category: "neutral" },
  { name: "Lê", category: "neutral" },
  { name: "Nati", category: "neutral" },
  { name: "Rê", category: "neutral" },
  { name: "Tati", category: "neutral" },
  { name: "Biba", category: "neutral" },
  { name: "Ceci", category: "neutral" },
  { name: "Zuzu", category: "neutral" },
  { name: "Tico", category: "neutral" },
  { name: "Teco", category: "neutral" },
  { name: "Didi", category: "neutral" },
  { name: "Dadá", category: "neutral" },
  { name: "Dedé", category: "neutral" },
  { name: "Dodo", category: "neutral" },
  { name: "Dudu", category: "neutral" },
  { name: "Lelé", category: "neutral" },
  { name: "Lili", category: "neutral" },
  { name: "Lolô", category: "neutral" },
  { name: "Mimi", category: "neutral" },
  { name: "Nana", category: "neutral" },
  { name: "Nono", category: "neutral" },
  { name: "Pipoca", category: "neutral" },
  { name: "Chocolate", category: "neutral" },
  { name: "Amendoim", category: "neutral" },
  { name: "Picolé", category: "neutral" },
  { name: "Jujuba", category: "neutral" },

  // Toys (Brinquedos)
  { name: "Bola", category: "toys" },
  { name: "Boneca", category: "toys" },
  { name: "Carrinho", category: "toys" },
  { name: "Urso de Pelúcia", category: "toys" },
  { name: "Lego", category: "toys" },
  { name: "Quebra-cabeça", category: "toys" },
  { name: "Pipa", category: "toys" },
  { name: "Pião", category: "toys" },
  { name: "Ioiô", category: "toys" },
  { name: "Bicicleta", category: "toys" },
  { name: "Patinete", category: "toys" },
  { name: "Skate", category: "toys" },
  { name: "Videogame", category: "toys" },
  { name: "Tabuleiro", category: "toys" },
  { name: "Dominó", category: "toys" },
  { name: "Corda de Pular", category: "toys" },
  { name: "Bolinha de Gude", category: "toys" },
  { name: "Massinha", category: "toys" },
  { name: "Giz de Cera", category: "toys" },
  { name: "Trenzinho", category: "toys" },
  { name: "Caminhão de Brinquedo", category: "toys" },
  { name: "Avião de Papel", category: "toys" },
  { name: "Foguete", category: "toys" },
  { name: "Barquinho", category: "toys" },
  { name: "Dardos", category: "toys" },
  { name: "Boliche Infantil", category: "toys" },
  { name: "Cesta de Basquete", category: "toys" },
  { name: "Trave de Gol", category: "toys" },
  { name: "Peteca", category: "toys" },
  { name: "Cavalinho de Balanço", category: "toys" },
  { name: "Cozinha de Brinquedo", category: "toys" },
  { name: "Ferramentas de Plástico", category: "toys" },
  { name: "Médico de Brinquedo", category: "toys" },
  { name: "Espada de Pirata", category: "toys" },
  { name: "Escudo", category: "toys" },
  { name: "Capacete de Astronauta", category: "toys" },
  { name: "Fantasia de Super-herói", category: "toys" },
  { name: "Máscara", category: "toys" },
  { name: "Capa", category: "toys" },
  { name: "Varinha de Condão", category: "toys" },
  { name: "Coroa de Princesa", category: "toys" },
  { name: "Estilingue", category: "toys" },
  { name: "Bumerangue", category: "toys" },
  { name: "Frisbee", category: "toys" },
  { name: "Piscina de Bolinhas", category: "toys" },
  { name: "Escorregador", category: "toys" },
  { name: "Balanço", category: "toys" },
  { name: "Gangorra", category: "toys" },
  { name: "Gira-gira", category: "toys" },
  { name: "Cama Elástica", category: "toys" },
  { name: "Mola Maluca", category: "toys" },
  { name: "Cubo Mágico", category: "toys" },
  { name: "Xadrez", category: "toys" },
  { name: "Damas", category: "toys" },

  // Utilities (Utilitários)
  { name: "Chave de Fenda", category: "utilities" },
  { name: "Martelo", category: "utilities" },
  { name: "Alicate", category: "utilities" },
  { name: "Tesoura", category: "utilities" },
  { name: "Caneta", category: "utilities" },
  { name: "Lápis", category: "utilities" },
  { name: "Borracha", category: "utilities" },
  { name: "Régua", category: "utilities" },
  { name: "Calculadora", category: "utilities" },
  { name: "Lanterna", category: "utilities" },
  { name: "Relógio", category: "utilities" },
  { name: "Guarda-chuva", category: "utilities" },
  { name: "Cadeado", category: "utilities" },
  { name: "Adaptador", category: "utilities" },
  { name: "Carregador", category: "utilities" },
  { name: "Fone de Ouvido", category: "utilities" },
  { name: "Garrafa Térmica", category: "utilities" },
  { name: "Canivete", category: "utilities" },
  { name: "Trena", category: "utilities" },
  { name: "Grampeador", category: "utilities" },
  { name: "Perfurador", category: "utilities" },
  { name: "Clipes", category: "utilities" },
  { name: "Fita Adesiva", category: "utilities" },
  { name: "Cola", category: "utilities" },
  { name: "Estilete", category: "utilities" },
  { name: "Compasso", category: "utilities" },
  { name: "Esquadro", category: "utilities" },
  { name: "Transferidor", category: "utilities" },
  { name: "Bloco de Notas", category: "utilities" },
  { name: "Agenda", category: "utilities" },
  { name: "Marcador de Texto", category: "utilities" },
  { name: "Lupa", category: "utilities" },
  { name: "Termômetro", category: "utilities" },
  { name: "Bússola", category: "utilities" },
  { name: "Isqueiro", category: "utilities" },
  { name: "Fósforo", category: "utilities" },
  { name: "Vela", category: "utilities" },
  { name: "Pilha", category: "utilities" },
  { name: "Bateria", category: "utilities" },
  { name: "Extensão", category: "utilities" },
  { name: "Benjamin", category: "utilities" },
  { name: "Parafuso", category: "utilities" },
  { name: "Prego", category: "utilities" },
  { name: "Porca", category: "utilities" },
  { name: "Arruela", category: "utilities" },
  { name: "Buchas", category: "utilities" },
  { name: "Nível", category: "utilities" },
  { name: "Serrote", category: "utilities" },
  { name: "Lima", category: "utilities" },
  { name: "Grosa", category: "utilities" },
  { name: "Pincel", category: "utilities" },
  { name: "Rolo de Pintura", category: "utilities" },
  { name: "Espátula", category: "utilities" },
  { name: "Desentupidor", category: "utilities" },

  // Clothes (Roupas)
  { name: "Camiseta", category: "clothes" },
  { name: "Calça Jeans", category: "clothes" },
  { name: "Bermuda", category: "clothes" },
  { name: "Vestido", category: "clothes" },
  { name: "Saia", category: "clothes" },
  { name: "Casaco", category: "clothes" },
  { name: "Moletom", category: "clothes" },
  { name: "Jaqueta", category: "clothes" },
  { name: "Meia", category: "clothes" },
  { name: "Cueca", category: "clothes" },
  { name: "Calcinha", category: "clothes" },
  { name: "Pijama", category: "clothes" },
  { name: "Boné", category: "clothes" },
  { name: "Touca", category: "clothes" },
  { name: "Luvas", category: "clothes" },
  { name: "Cachecol", category: "clothes" },
  { name: "Cinto", category: "clothes" },
  { name: "Tênis", category: "clothes" },
  { name: "Sapato", category: "clothes" },
  { name: "Sandália", category: "clothes" },
  { name: "Chinelo", category: "clothes" },
  { name: "Bota", category: "clothes" },
  { name: "Salto Alto", category: "clothes" },
  { name: "Sapatilha", category: "clothes" },
  { name: "Mocassim", category: "clothes" },
  { name: "Gravata", category: "clothes" },
  { name: "Lenço", category: "clothes" },
  { name: "Suspensório", category: "clothes" },
  { name: "Meia-calça", category: "clothes" },
  { name: "Legging", category: "clothes" },
  { name: "Shorts", category: "clothes" },
  { name: "Regata", category: "clothes" },
  { name: "Blusa", category: "clothes" },
  { name: "Camisa", category: "clothes" },
  { name: "Terno", category: "clothes" },
  { name: "Sobretudo", category: "clothes" },
  { name: "Capa de Chuva", category: "clothes" },
  { name: "Maiô", category: "clothes" },
  { name: "Biquíni", category: "clothes" },
  { name: "Sunga", category: "clothes" },
  { name: "Roupão", category: "clothes" },
  { name: "Kimono", category: "clothes" },
  { name: "Blazer", category: "clothes" },
  { name: "Colete", category: "clothes" },
  { name: "Jardineira", category: "clothes" },
  { name: "Macacão", category: "clothes" },
  { name: "Top", category: "clothes" },
  { name: "Body", category: "clothes" },
  { name: "Sutiã", category: "clothes" },
  { name: "Baby Doll", category: "clothes" },
  { name: "Camisola", category: "clothes" },
  { name: "Sunglass", category: "clothes" },
  { name: "Óculos", category: "clothes" },
  { name: "Relógio de Pulso", category: "clothes" },
];
